import { isMobileScreen } from '@apply/ui';
import { MakeAnotherPaymentButton } from './components/MakeAnotherPaymentButton';
import { CloseButton } from './components/CloseButton';

export const FinishedButtonPanel = () => {
    const mobileScreen = isMobileScreen();
    return (
        <>
            <div className={`customPayment-buttonPanel ${mobileScreen ? 'mobile' : ''}`}>
                <CloseButton />
                <MakeAnotherPaymentButton />
            </div>
        </>
    );
};
